module.exports = __webpack_public_path__ + "static/img/middle7.c71655a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/middle7.jpg
// module id = 7pbQ
// module chunks = 9